import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const SpocmacyColtoralHeritage = () => {
  const homeMenu = [
    { label: "MUN", link: "/Mun" },
    { label: "Glory to the Nation", link: "/GloryOfNation" },
    {
      label: "Spic Macay Cultural and Heritage Club",
      link: "/SpocmacyColtoralHeritage",
    },
    {
      label: "Vocational Education Clubs (Middle Wing) ",
      link: "/vocationalClubmiddle",
    },
    {
      label: "Vocational Education Clubs (Senior Wing)",
      link: "/vocationalClub",
    },
    {
      label: "Vocational Education Clubs (Primary Wing)",
      link: "/VocationalClubPrimary",
    },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/blog-banner.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Spic Macay Cultural and Heritage Club"
                breadEnd="Spic Macay Cultural and Heritage Club"
                breadMid="Spic Macay Cultural and Heritage Club"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <h4>
                SPIC MACAY – VIDUSHI KAVITA DWIBEDI JI
                <br />
                26th September 2025
              </h4>
              <p>
                As part of its endeavour to nurture cultural awareness among
                students, our school, under the aegis of SPIC MACAY (Society for
                the Promotion of Indian Classical Music and Culture Amongst
                Youth), had the privilege of hosting an Odissi dance recital by
                the world renowned artiste Vidushi Kavita Dwibedi Ji.
                Accompanied by illustrious artists – Shri Prashant Behera on
                vocal, Shri Prashant Mangaraj on the mridangam, and Shri
                Gopinath Swain on the violin, their collaborative performance
                offered the learners of Grades VIII and IX, a rare opportunity
                to witness the Odissi dance style in its purest form.
              </p>

              <p>
                In a thoughtful prelude to the dance recital, Vidushi Kavita
                Dwibedi Ji unraveled the essence of Odissi that is deeply rooted
                in temple culture and spirituality. Through the interwoven
                elements of Bhava, Bhakti and Rasa, and the interdisciplinary
                aspect of the dance form, the audience was edified with the
                meaning behind every gesture and movement. The recital commenced
                with Mangalacharan—a graceful and devotional invocation
                dedicated to Goddess Durga, setting a sanctified tone for the
                performances that followed.
              </p>

              <p>
                In the interaction with the learners, Vidushi Kavita Dwibedi Ji
                shared insights on her sources of inspiration, the idea of
                mastering a craft, and the role of students in preserving
                India’s cultural heritage, giving the learners a chance to
                explore the relevance of classical traditions in contemporary
                times. The morning left the learners not only mesmerized by the
                beauty of Odissi but also inspired to cherish and uphold the
                timeless traditions of our country.
              </p>
            </div>

            <div className="row flexbox-v zoompic">
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-1.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-1.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-2.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-2.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-3.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-3.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-4.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-4.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-5.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-5.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-6.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-6.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-7.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-7.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-8.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-8.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-9.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-9.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-10.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-10.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-11.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-11.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-12.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-12.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-13.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-13.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-14.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-14.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-15.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SPICMACAY-26-09-25-15.JPG"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col-lg-12">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/IMG-20220209-WA0006.jpg"
                  className="img-fluid wid-100 mb-4"
                  alt="Lotus Valley School, Gurgaon"
                />
              </LazyLoad>
              <h4>Upcoming Event</h4>
              <p>
                Lotus Drishti2022: The Perspective is one of the foremost
                efforts by LVISG for its sustained promotion and propagation of
                Art integrated approach to learning. Drishti provides
                opportunities for innovation and creativity in all its training
                as well as performing activities.
              </p>
              <p>
                The objective is to create more art-lovers for perpetuation of
                art in society. The mission of Drishti is not only to inspire
                artists and art lovers, but also to popularize art integrated
                learning among common people.This event gives provides and
                creates a platform to observe , decipher: critically and
                analytically ; create and express: views and opinions ,
                developing new perspectives through the medium of art bringing
                an all new insight to the already known facts, events and data.
              </p>
              <p>
                We look forward to welcoming all to create masterpieces and
                bring new insights and perspectives in the learning process.
                Through the events, we aim to empower the learners to learn the
                world of Humanities and unleash their creative genius and
                inspire us all .
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default SpocmacyColtoralHeritage;
